<template lang="html">
  <div class="grid-toggler" @click="toggleLayout2()">
    <div class="list-grid-toggle">
      <div class="icon" :class="{ 'icon-grid': layoutName === 'grid' }">
        <div class="icon-bar"></div>
        <div class="icon-bar"></div>
        <div class="icon-bar"></div>
      </div>
    </div>
    <span class="label1">{{ layoutName }}</span>

    <br /><br /><br />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  mounted() {},

  data() {
    return {
      animate: false,
      layoutName: "list"
    };
  },

  components: {},

  computed: {},

  methods: {
    toggleLayout2() {
      this.layoutName = this.layoutName === "grid" ? "list" : "grid";
      this.$emit("toggleLayout", this.layoutName);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

$white: #ecf0f1;
$teal: #16a085;

$primary-color: $white;
$secondary-color: $teal;

.grid-toggler {
  display: flex;
  flex-direction: column;
  width: 50px;
  text-align: center;

  transition: all 0.15s ease;
  user-select: none;
  cursor: pointer;

  .label1 {
    font-size: 12px;
    font-weight: 200;
    letter-spacing: 3px;
    text-transform: uppercase;
    margin-top: 10px;
  }
}

.list-grid-toggle {
  width: 30px;
  height: 40px;
  padding: 25px;
  background: $primary-blue;
  border-radius: 50%;
  text-align: center;
  text-shadow: 2px 2px 4px shade($secondary-color, 20%);

  &:hover {
    background: shade($secondary-color, 10%);
  }

  .label {
    color: black;
    margin-left: -15px;
  }
}

.icon {
  width: 30px;
  margin-bottom: 15px;
  margin-left: -15px;
  margin-top: -12px;
}

.icon-bar {
  position: relative;
  width: 30px;
  height: 3px;
  margin: 2px auto 6px auto;
  background: $primary-color;

  box-shadow: 2px 2px 4px shade($secondary-color, 20%);
  transition: all 0.15s ease;

  &:last-child {
    margin-bottom: 0;
  }

  &:before,
  &:after {
    position: absolute;
    display: block;
    width: 5px;
    height: 5px;
    background: $primary-color;

    box-shadow: 2px 2px 4px (shade($secondary-color, 20%));
    content: "";
    opacity: 0;
    transition: all 0.15s ease;
  }

  &:before {
    left: -10px;
  }

  &:after {
    right: -10px;
  }
}

.icon-grid {
  .icon-bar {
    margin: 0 auto 5px auto;
    height: 5px;
    width: 5px;

    &:before,
    &:after {
      opacity: 1;
    }

    &:before {
      left: 0;
      transform: translateX(-10px);
    }

    &:after {
      right: 0;
      transform: translateX(10px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wardrobe/outfits/LayoutToggle.vue